import { Swiper } from 'swiper/react'
import { Navigation } from 'swiper/modules'

import { SliderArrowLeft } from '@assets/svgs/SliderArrowLeft'
import { SliderArrowRight } from '@assets/svgs/SliderArrowRight'

import type { SladerProps } from './types'

import * as S from './styles'
import 'swiper/css'

export const Slider = ({ items }: SladerProps) => {
  if (!items?.length) return null

  return (
    <S.Container>
      <Swiper
        modules={[Navigation]}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }}
        spaceBetween={10}
        slidesPerView="auto"
        centeredSlides={false}
        freeMode={true}
      >
        {items.map((item, index) => (
          <S.Slide key={index}>{item}</S.Slide>
        ))}
      </Swiper>

      <S.LeftButton className="swiper-button-prev">
        <SliderArrowLeft />
      </S.LeftButton>

      <S.RightButton className="swiper-button-next">
        <SliderArrowRight />
      </S.RightButton>
    </S.Container>
  )
}
